import { signOut } from 'aws-amplify/auth'

const IDLE_TIMEOUT_MS = 8 * 60 * 60 * 1000
const LAST_ACTIVITY_KEY = 'notefie_last_activity_at'
const ACTIVITY_DEBOUNCE_MS = 30_000

export function touchSessionActivity(): void {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()))
}

export function clearSessionActivity(): void {
  localStorage.removeItem(LAST_ACTIVITY_KEY)
}

export function ensureSessionActivityTimestamp(): void {
  if (!localStorage.getItem(LAST_ACTIVITY_KEY)) {
    touchSessionActivity()
  }
}

export function isSessionIdleExpired(): boolean {
  const raw = localStorage.getItem(LAST_ACTIVITY_KEY)
  if (!raw) {
    return false
  }
  const last = Number(raw)
  if (!Number.isFinite(last)) {
    return false
  }
  return Date.now() - last > IDLE_TIMEOUT_MS
}

export async function expireIdleSession(): Promise<boolean> {
  if (!isSessionIdleExpired()) {
    return false
  }
  clearSessionActivity()
  try {
    await signOut()
  } catch {}
  return true
}

export function startIdleSessionWatch(onExpired: () => void): () => void {
  const events: Array<keyof WindowEventMap> = ['mousedown', 'keydown', 'scroll', 'touchstart']
  let lastTouch = 0

  const onActivity = () => {
    const now = Date.now()
    if (now - lastTouch < ACTIVITY_DEBOUNCE_MS) {
      return
    }
    lastTouch = now
    touchSessionActivity()
  }

  events.forEach((event) => window.addEventListener(event, onActivity, { passive: true }))
  const intervalId = window.setInterval(async () => {
    if (await expireIdleSession()) {
      onExpired()
    }
  }, 60_000)

  return () => {
    events.forEach((event) => window.removeEventListener(event, onActivity))
    window.clearInterval(intervalId)
  }
}
